import { Geolocation, Location } from ".."

export interface ModifyLocation {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    geolocation: Geolocation
}

export class ModifyLocationFactory {
    static create(): ModifyLocation {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            geolocation: { latitude: null, longitude: null },
        }
    }

    static from(location: Location): ModifyLocation {
        const modifyLocation: ModifyLocation = JSON.parse(
            JSON.stringify({
                isDraft: location.isDraft,
                isActive: location.isActive,
                isDeleted: location.isDeleted,
                names: location.names,
                geolocation: location.geolocation ?? { latitude: null, longitude: null },
            })
        )
        return modifyLocation
    }
}
